import type { NavigationGuard } from 'vue-router'

import { useAuthStore } from '@/stores/auth.stores'
import { useUserStore } from '@/stores/user.stores'

export const publicGuard: NavigationGuard = async () => {
  const authStore = useAuthStore()
  const userStore = useUserStore()

  const isAuthenticated = await authStore.authenticate()
  if (isAuthenticated) {
    await userStore.initialize()
  }

  return true
}
